import { render, staticRenderFns } from "./OnboardingPaymentPreferencesPage.vue?vue&type=template&id=081cd9de&scoped=true&"
import script from "./OnboardingPaymentPreferencesPage.vue?vue&type=script&lang=ts&"
export * from "./OnboardingPaymentPreferencesPage.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingPaymentPreferencesPage.vue?vue&type=style&index=0&id=081cd9de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081cd9de",
  null
  
)

export default component.exports